import { IconButton, useDisclosure } from '@chakra-ui/react';
import { QuestionIcon } from '@chakra-ui/icons';
import { TournamentScoringHelpModal } from './modals/TournamentScoringHelpModal';

export function TournamentScoringHelpButton(props: { size?: string; fontSize?: string }) {
  const { size = 'sm', fontSize = 'xs' } = props;
  const disclosure = useDisclosure();

  return (
    <>
      <IconButton
        aria-label='How scoring works'
        icon={<QuestionIcon />}
        size={size}
        fontSize={fontSize}
        variant='ghost'
        minW={6}
        h={6}
        onClick={disclosure.onOpen}
      />
      <TournamentScoringHelpModal isOpen={disclosure.isOpen} onClose={disclosure.onClose} />
    </>
  );
}
